<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <loading v-show="isLoading"></loading>
    </transition>
    <b-modal
      size="lg"
      @close="hideModal"
      ref="modal-attCadastroPessoa"
      scrollable
      centered
      hide-header-close
      no-close-on-backdrop
    >
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> Atenção
      </template>
      <p class="warn__subtitle">
        Olá, foi identificado que é necessário atualizar o cadastro para a
        pessoa deste card em questão.<br /><br />
        Caso deseje prosseguir com a ação, sera necessário realizar a
        atualização clicando no botão 'Continuar' logo a baixo!<br /><br />
        <strong>Observação:</strong> Se não informar o CPF/CNPJ, a visita será
        concluída mantendo a pessoa atual.
      </p>
      <template #modal-footer>
        <div
          style="gap: 0.5rem"
          class="d-flex align-end"
        >
          <DefaultButton
            :disabled="isLoading"
            btnVariant="btn-danger"
            :onClick="abort"
            text="Cancelar"
          />
          <DefaultButton
            :disabled="isLoading"
            btnVariant="btn-third"
            :onClick="onContinue"
            text="Continuar"
          />
        </div>
      </template>
      <FormAttCadastroPessoaModal ref="FormAttCadastroPessoaModal" />
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'

import Loading from '@/components/UI/Loading'
import FormAttCadastroPessoaModal from '@/components/UI/attCadastroPessoaModal/FormAttCadastroPessoaModal.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'AttCadastroPessoaModal',
  mixins: [ActionsForm],
  components: {
    Loading,
    DefaultButton,
    FormAttCadastroPessoaModal
  },
  data () {
    return {
      pessoaId: null, // ID da pessoa a ser atualizado
      isLoading: false, // Indica se há uma operação em andamento
      resolvePromise: null, // Função de resolução da Promise
      rejectPromise: null // Função de rejeição da Promise
    }
  },
  methods: {
    /**
     * Exibe o modal e inicializa o ID da pessoa.
     * Retorna uma Promise para controle externo.
     * @param {Number} pessoaId - ID da pessoa a ser atualizada.
     * @returns {Promise} Promise que será resolvida ou rejeitada.
     */
    showModal (pessoaId) {
      this.$refs['modal-attCadastroPessoa'].show()
      this.pessoaId = pessoaId

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    /**
     * Oculta o modal.
     */
    hideModal () {
      this.$refs['modal-attCadastroPessoa'].hide()
    },

    /**
     * Cancela a operação e rejeita a Promise com uma mensagem padrão.
     */
    abort () {
      if (this.rejectPromise) {
        this.rejectPromise(
          new CustomError('Usuário cancelou a atualização cadastral.', {
            cause: 'action_canceled',
            level: 'warning',
            title: 'Operação cancelada'
          })
        )
      }
      this.hideModal()
    },

    /**
     * Continua com o processo de atualização cadastral.
     * Realiza validações e chama o componente filho para salvar os dados.
     */
    async onContinue () {
      try {
        this.isLoading = true

        if (!this.pessoaId) {
          throw new CustomError(
            'ID da pessoa não foi especificado para atualização.',
            {
              cause: 'not_found',
              level: 'error'
            }
          )
        }

        // Exibe o modal do formulário de atualização
        await this.$refs.FormAttCadastroPessoaModal.showModal(this.pessoaId)

        if (this.resolvePromise) {
          this.resolvePromise(true)
        }

        this.hideModal()
      } catch (error) {
        console.error('Erro durante a atualização cadastral:', error)

        if (this.rejectPromise) {
          this.rejectPromise(error)
        }

        this.hideModal()
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="scss">
.warn {
  &__tittle {
    color: #f00;
    font-size: 1rem;
    font-weight: 600;
  }
  &__subtitle {
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
  }
  hr {
    margin: 1.25rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/attCadastroPessoaModal/AttCadastroPessoaModal.vue